import _Space from "@arco-design/web-react/es/Space";
import _Divider from "@arco-design/web-react/es/Divider";
import _Link from "@arco-design/web-react/es/Link";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _Menu from "@arco-design/web-react/es/Menu";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import _Button from "@arco-design/web-react/es/Button";
import _Popover from "@arco-design/web-react/es/Popover";
import _Select from "@arco-design/web-react/es/Select";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { IconToTop, IconLeft, IconEye, IconImport, IconCopy } from '@arco-design/web-react/icon';
import { useSelector, useDispatch } from 'react-redux';
import style from './style.less';
import ThemePublish from '../themePublish';
import AutoSaveToken from './autoSave/index';
import DropdownMenu from './dropdown';
import StepHistory from './stepHistory';
import ThemeOwner from './themeOwner';
import ToggleTheme from './toggleTheme';
import Preview from './preview';
import CopyTheme from '@src/pages/common/themeCopy';
import VoteIcon from '@src/pages/common/voteIcon';
import useLocale from '@src/hooks/useLocale';
import postMessage, { postPreviewMessage, POST_MESSAGE_ACTIONS } from '@src/utils/postMessage';
import useBreadcrumb, { formatDesignPageUrl } from '@src/utils/hooks/useBreadcrumb';
import HistoryPreviewSelect from './version-preview-select';
var Option = _Select.Option;
export default function NavHeader(_a) {
  var isPreviewPage = _a.isPreviewPage;
  var _b = useLocale(),
    t = _b.t,
    lang = _b.lang,
    setLang = _b.setLang,
    localeOptions = _b.localeOptions;
  var fromUrl = useBreadcrumb().fromUrl;
  var _c = useSelector(function (state) {
      return {
        themeInfo: state.theme.themeConfig,
        readonly: !state.theme.themeConfig.isMine,
        themeMode: state.theme.themeMode
      };
    }),
    themeInfo = _c.themeInfo,
    readonly = _c.readonly,
    themeMode = _c.themeMode;
  var dispatch = useDispatch();
  var actionBtn = window.__user__ ? /*#__PURE__*/React.createElement(_Popover, {
    content: t['nav.action.copy.content'],
    disabled: themeInfo.canCopy
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CopyTheme, {
    theme: themeInfo,
    disabled: !themeInfo.canCopy
  }, /*#__PURE__*/React.createElement(_Button, {
    shape: "round",
    type: "primary",
    disabled: !themeInfo.canCopy,
    icon: /*#__PURE__*/React.createElement(IconCopy, null),
    size: "large",
    className: style['action-button']
  }, t['nav.action.copy.btn'])))) : /*#__PURE__*/React.createElement(_Dropdown, {
    position: "br",
    droplist: /*#__PURE__*/React.createElement(_Menu, {
      onClickMenuItem: function onClickMenuItem() {
        location.href = "/common/login?redirectUrl=" + location.href;
      }
    }, /*#__PURE__*/React.createElement(_Menu.Item, {
      key: "login"
    }, /*#__PURE__*/React.createElement(IconImport, null), " ", t['nav.action.login']))
  }, /*#__PURE__*/React.createElement(_Avatar, {
    size: 32
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    style: {
      stroke: 'none'
    },
    className: "arco-icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.384 16 15.9444 12.4736 15.9994 8.10267L16.0001 8.0803V4.21053H16V5.33333H10.6924C11.3706 6.01805 11.7895 6.96011 11.7895 8C11.7895 8.04704 11.7886 8.09389 11.7869 8.14052C11.7845 8.1958 11.78 8.27529 11.7717 8.36905C11.5862 10.2887 9.96836 11.7895 8 11.7895C5.90713 11.7895 4.21053 10.0929 4.21053 8C4.21053 5.90713 5.90713 4.21053 8 4.21053C9.03989 4.21053 9.98195 4.62939 10.6667 5.3076V0H8H7.93562L7.89557 0.000667676C3.52542 0.0565765 0 3.61659 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: themeMode === 'dark' ? '#C9CDD4' : 'var(--color-white)'
  }), /*#__PURE__*/React.createElement("rect", {
    x: "10.6667",
    width: "5.33333",
    height: "5.33333",
    fill: themeMode === 'dark' ? '#AFB5BF' : 'var(--color-white)',
    fillOpacity: themeMode === 'dark' ? 1 : 0.6
  }))));
  var changeLocale = function changeLocale(value) {
    setLang && setLang(value);
    postMessage(POST_MESSAGE_ACTIONS.CHANGE_LOCALE, value);
    postPreviewMessage('changeLocale', value);
    localStorage.setItem('arco-locale', value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: style.nav
  }, /*#__PURE__*/React.createElement("div", {
    className: style['nav-header']
  }, !themeInfo.isMine && !isPreviewPage ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Link, {
    className: style['nav-back'],
    onClick: function onClick() {
      var href = formatDesignPageUrl(themeInfo.themeId, 'preview', fromUrl);
      location.href = href;
    }
  }, /*#__PURE__*/React.createElement(IconLeft, null), /*#__PURE__*/React.createElement("span", null, t['nav.action.back.preview'])), /*#__PURE__*/React.createElement(_Divider, {
    type: "vertical"
  })) : /*#__PURE__*/React.createElement("a", {
    onClick: function onClick() {
      var href = fromUrl && fromUrl !== location.href ? fromUrl : '/themes/stores';
      location.href = href;
    },
    className: style['nav-back']
  }, /*#__PURE__*/React.createElement(IconLeft, null)), /*#__PURE__*/React.createElement(DropdownMenu, {
    isPreviewPage: isPreviewPage,
    theme: themeInfo,
    readonly: readonly
  }), /*#__PURE__*/React.createElement(_Divider, {
    type: "vertical"
  }), /*#__PURE__*/React.createElement(AutoSaveToken, {
    themeInfo: themeInfo,
    readonly: readonly
  }), themeInfo.isMine && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Divider, {
    type: "vertical"
  }), /*#__PURE__*/React.createElement(StepHistory, null))), /*#__PURE__*/React.createElement("div", {
    className: style['nav-actions']
  }, themeInfo.isMine ? /*#__PURE__*/React.createElement(HistoryPreviewSelect, {
    themeInfo: themeInfo
  }) : null, /*#__PURE__*/React.createElement(ToggleTheme, null), /*#__PURE__*/React.createElement(_Divider, {
    type: "vertical"
  }), /*#__PURE__*/React.createElement(ThemeOwner, {
    readonly: readonly,
    themeInfo: themeInfo
  }), /*#__PURE__*/React.createElement(_Divider, {
    type: "vertical"
  }), /*#__PURE__*/React.createElement("div", {
    className: style['locale-select']
  }, /*#__PURE__*/React.createElement(_Select, {
    defaultValue: lang,
    trigger: ['hover'],
    bordered: false,
    style: {
      width: 86
    },
    onChange: changeLocale
  }, localeOptions.map(function (option) {
    return /*#__PURE__*/React.createElement(Option, {
      key: option.value,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/React.createElement(_Link, {
    hoverable: false,
    className: style['help-doc-link'],
    href: "/docs/designlab/guideline",
    target: "_blank"
  }, t['nav.link.guideline']), /*#__PURE__*/React.createElement(_Divider, {
    type: "vertical"
  }), /*#__PURE__*/React.createElement(_Space, {
    size: 12,
    style: {
      marginRight: 12
    }
  }, /*#__PURE__*/React.createElement(VoteIcon, {
    render: function render(dom) {
      return /*#__PURE__*/React.createElement(_Button, {
        shape: "round",
        size: "large",
        className: style['action-button']
      }, dom);
    },
    type: "like",
    theme: themeInfo,
    showCount: {
      style: {
        marginLeft: 6
      }
    },
    onOk: function onOk(st) {
      dispatch({
        type: 'updateThemeConfig',
        payload: __assign(__assign({}, themeInfo), {
          statistic: st
        })
      });
    }
  }), /*#__PURE__*/React.createElement(VoteIcon, {
    render: function render(dom) {
      return /*#__PURE__*/React.createElement(_Button, {
        shape: "round",
        size: "large",
        className: style['action-button']
      }, dom);
    },
    type: "star",
    theme: themeInfo,
    showCount: {
      style: {
        marginLeft: 6
      }
    },
    onOk: function onOk(st) {
      dispatch({
        type: 'updateThemeConfig',
        payload: __assign(__assign({}, themeInfo), {
          statistic: st
        })
      });
    }
  })), isPreviewPage ? /*#__PURE__*/React.createElement(_Space, {
    size: 8
  }, /*#__PURE__*/React.createElement(_Button, {
    shape: "round",
    onClick: function onClick() {
      location.href = formatDesignPageUrl(themeInfo.themeId);
    },
    icon: /*#__PURE__*/React.createElement(IconEye, null),
    size: "large",
    className: style['action-button']
  }, t['nav.action.viewDetail']), actionBtn) : /*#__PURE__*/React.createElement(_Space, {
    size: 12
  }, themeInfo.isMine && /*#__PURE__*/React.createElement(Preview, {
    themeInfo: themeInfo
  }, /*#__PURE__*/React.createElement(_Button, {
    shape: "round",
    icon: /*#__PURE__*/React.createElement(IconEye, null),
    size: "large",
    className: style['action-button']
  }, t['nav.action.preview'])), themeInfo.isMine && /*#__PURE__*/React.createElement(ThemePublish, null, /*#__PURE__*/React.createElement(_Button, {
    shape: "round",
    type: "primary",
    className: style['action-button'],
    size: "large",
    icon: /*#__PURE__*/React.createElement(IconToTop, null)
  }, themeInfo.packageName ? t['nav.action.package.publish.update'] : t['nav.action.package.publish'])), !themeInfo.isMine && actionBtn)));
}